import { Box, Typography } from '@mui/material'
import type { ProcurementFilters } from '../ProcurementPage'

interface Props {
  filters: ProcurementFilters
}

export default function ProcurementGoodAllocationListView({ filters }: Props) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="h6" fontWeight={700}>
        Good Allocation
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This tab will host the Procurement Good Allocation grid and toolbar from
        {' '}
        <strong>form_frmProcurementMainSubFormGoodAlc.txt</strong>
        {' '}
        and
        {' '}
        <strong>form_frmProcurementQryGoodAlc.txt</strong>
        , including New / Edit / Delete / Copy / Mass Upload / Truck Status / Tick All / Print BBGN actions.
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Current header filters: startDate={filters.startDate}, endDate={filters.endDate}, isForcedClose=
        {filters.isForcedClose}
        .
      </Typography>
    </Box>
  )
}

